module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-14@2x-b2aaf8885888038208c25cf9a316b9df.png";